if(!customElements.get('anchor-button')) {
  class ComponentAnchorButton extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button');
      this.anchorId = this.dataset.anchorId;
      console.log(this)
      this.button.addEventListener('click', ()=> {
        var target = document.getElementById(this.anchorId);
        console.log(target)
        if(target)
          $s.scrollToElement(target, 40);
      })
    }

    

  }
  customElements.define('anchor-button', ComponentAnchorButton);
}